import React from 'react'
import { Spring, config } from 'react-spring/renderprops'
import profile from '../assets/profile.jpg'

import './styles/About.css'

const AboutScreen = () => {
  return (
    <Spring
      from={{ transform: 'scale(0.9)' }}
      to={{ transform: 'scale(1)' }}
      config={config.wobbly}
    >
      {props => (
        <div style={props}>
          <div className='card about-card'>
            <img src={profile} alt='Profile Pic' />
            <h4>Software Developer</h4>
            <h2>Manish</h2>
            <h3>Kolkata, India</h3>
          </div>
          <div className='description'>
            <p>
              Hi, I'm <strong>Manish.</strong> My life is an experiment. I follow my curiosity wherever it takes me,
              trusting the dots will connect eventually. Currently I'm working as a full stck develepor at 
              <strong> Tata Consultancy Services</strong>. I have <strong>2 years of experience </strong> 
              building scalable, enterprise-grade web applications using technologies like 
              <strong> React, Java, Spring Boot</strong>, and DevOps tools including 
              <strong> Docker, Kubernetes</strong>, and CI/CD pipelines.
            </p>
            <p>
              I'm always looking to learn new technologies, collaborate on impactful projects, and create 
              solutions that address real-world problems.<strong> Check out the <a href="https://mjdevfolio.netlify.app/" target="_blank" rel="noopener noreferrer">
              cool shit
            </a> I,ve been working on.</strong>
            </p>
          </div>
          <div className='label'>
            <a href='https://www.buymeacoffee.com/reetpriye'>
              Buy me a coffee <i className='fas fa-coffee'></i>{' '}
            </a>
          </div>
        </div>
      )}
    </Spring>
  )
}

export default AboutScreen
